var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 21"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#E85298",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  clipPath: "url(#icon_marker_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.063 8.83c0 5.846-7.875 10.857-7.875 10.857S1.311 14.676 1.311 8.83c0-1.993.83-3.905 2.307-5.315 1.477-1.41 3.48-2.202 5.568-2.202 2.09 0 4.092.792 5.569 2.202 1.477 1.41 2.306 3.322 2.306 5.315Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.188 11.812a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_marker_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18.375v21H0z"
})))));
export default SvgIconMarker;